export default function Star() {
    return (
        <svg className="star" width="98" height="100" viewBox="0 0 98 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.99">
                <g filter="url(#filter0_f_1659_26153)">
                    <path
                        d="M52.8351 18.3323L50.9337 48.2585L79.1478 52.6731L50.5013 51.8283L45.1905 81.4391L47.0919 51.513L18.8779 47.0983L47.5244 47.9431L52.8351 18.3323Z"
                        fill="url(#paint0_radial_1659_26153)"
                    />
                </g>
                <g opacity="0.7" filter="url(#filter1_f_1659_26153)">
                    <path
                        d="M52.8351 18.3323L53.0948 46.4278L79.1478 52.6731L52.1758 54.0138L45.1905 81.4391L44.9309 53.3436L18.8779 47.0983L45.8498 45.7577L52.8351 18.3323Z"
                        fill="url(#paint1_radial_1659_26153)"
                    />
                </g>
                <ellipse
                    cx="49.2882"
                    cy="50.1187"
                    rx="2.52466"
                    ry="2.67173"
                    transform="rotate(21.1157 49.2882 50.1187)"
                    fill="url(#paint2_radial_1659_26153)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_f_1659_26153"
                    x="16.8779"
                    y="16.332"
                    width="64.2695"
                    height="67.1074"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_1659_26153" />
                </filter>
                <filter
                    id="filter1_f_1659_26153"
                    x="10.8779"
                    y="10.332"
                    width="76.2695"
                    height="79.1074"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="4" result="effect1_foregroundBlur_1659_26153" />
                </filter>
                <radialGradient
                    id="paint0_radial_1659_26153"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(49.0128 49.8857) rotate(96.9071) scale(31.7841 30.2515)"
                >
                    <stop offset="0.18" stopColor="white" />
                    <stop offset="1" stopColor="white" stop-opacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint1_radial_1659_26153"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(49.0128 49.8857) rotate(96.9071) scale(31.7841 30.2515)"
                >
                    <stop offset="0.18" stopColor="white" />
                    <stop offset="1" stopColor="white" stop-opacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint2_radial_1659_26153"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(49.2882 50.1187) rotate(90) scale(2.67173 2.52466)"
                >
                    <stop offset="0.165" stopColor="white" />
                    <stop offset="1" stopColor="white" stop-opacity="0" />
                </radialGradient>
            </defs>
        </svg>
    );
}
